var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.authenticated)?_c('div',[_c('NavBar')],1):_vm._e(),_c('v-main',[_c('router-view',{on:{"authenticated":_vm.setAuthenticated}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }